angular.module('impactx.rfq').controller('RFQListOpenSupplierCtrl', ['$scope', '$redirect', 'selectedListItems', RFQListOpenSupplierCtrl]);

function RFQListOpenSupplierCtrl($scope, $redirect, selectedListItems)
{
    var self = this;

    this.getDetailLink = function() {
        return impactX.isDefined(selectedListItems.getFirstSelectedItem(), "isMultiSupplier.value") ?
            "multirfq/" + selectedListItems.getFirstSelectedId() : "singlerfqsupplier/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: self.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFQSupplier'}
    ];

    this.meta = {
        rowTemplate: 'modules/rfq/templates/rfqlistsupplier.row.tmpl.html',
        filtersTemplate: 'modules/rfq/templates/rfqlistsupplier.filters.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfq/listopensupplier',
        id: "rfqlistopensupplier",
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };

    this.processStatus = {value: "open"};
    $scope.$watch(function() {
        return self.processStatus.value;
    }, function(newValue) {
        if(newValue === "closed") {
            $redirect.redirectTo(null, "/rfqlistclosedsupplier");
        }
    });
}